import { render, staticRenderFns } from "./ExScroll.vue?vue&type=template&id=c575b314&scoped=true&"
import script from "./ExScroll.vue?vue&type=script&lang=js&"
export * from "./ExScroll.vue?vue&type=script&lang=js&"
import style0 from "./ExScroll.vue?vue&type=style&index=0&id=c575b314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c575b314",
  null
  
)

export default component.exports